import { z } from "zod";

// ==========================================
// #region ENERGIA
// ==========================================

export const ControleEnergiaSchema = z.object({
  idObra: z.number().nullish(),
  idControleEnergia: z.number().nullish(),
  ano: z.coerce.number().nullish(),
  idDescricaoMes: z.coerce.number().nullish(),
  kwH: z.coerce.number().nullish(),
  valor: z.coerce.number().nullish(),
  areaConstruida: z.coerce.number().nullish(),
  mediaKwhM2: z.coerce.number().nullish(),
  metaAprovacao: z.coerce.number().nullish(),
  diasMedicao: z.coerce.number().nullish(),
  efetivoMes: z.coerce.number().nullish(),
  observacao: z.coerce.string().nullish(),
});

export type ControleEnergiaForm = z.infer<typeof ControleEnergiaSchema>;

// #endregion
